import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import { Box } from "@mui/material";
import br from "date-fns/locale/pt-BR";
import React, {

  ReactElement,

} from "react";

import style from "./CSVDetalhesModal.module.css";

export default function CSVDetalhesModalDetalhe(
  props: CSVDetalhesModalDetalhePropsTypes
) {
  const detalhesFormatados: string[] = props.detalhes
    .replaceAll("=>", "")
    .split("\r\n");

  var detalhesFormatados2 = detalhesFormatados.map((item) => {
    let subArray: string[] = item.split("\t");
    subArray.shift();
    return subArray;
  });

  function montarCabecalho(cabecalho: string[]): ReactElement {
    return (
      <>
        <tr>
          {cabecalho.map((item, index) => {
            return index % 2 == 0 ? (
              <th className={style.th__celula}>{item}</th>
            ) : null;
          })}
        </tr>
      </>
    );
  }

  function montarDados(dados: string[][]): ReactElement {
    return (
      <>
        {dados.map((linha, index) => {
          return index > 0 ? (
            <tr>
              {linha.map((item, index) => {
                return index % 2 == 0 ? (
                  <td
                    className={`${style.td__celula} ${
                      linha[index + 1].includes("Válido")
                        ? style.td__sucesso
                        : style.td__fracasso
                    }`}
                  >
                    {item}
                  </td>
                ) : null;
              })}
            </tr>
          ) : null;
        })}
      </>
    );
  }

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterlocale={br}>
        <Box
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"space-between"}
          height={"60vh"}
          alignItems={"end"}
          margin={"0.5rem"}
        >
          <div className={style.div__detalhes}>
            <table>
              <thead>{montarCabecalho(detalhesFormatados2[0])}</thead>
              <tbody>{montarDados(detalhesFormatados2)}</tbody>
            </table>
          </div>
        </Box>
      </LocalizationProvider>
    </>
  );
}

interface CSVDetalhesModalDetalhePropsTypes {
  handleClose: any;
  name: string;
  detalhes: string;
}
